import { Author } from '../../../api/Author';

export const isMissingAuthorByTokenFunction = (error: { message?: string } | null): boolean =>
  Boolean(error?.message?.toLowerCase().includes('author_by_token'));

export const requireAuthorPayload = (
  author: Author | null,
  errorMessage: string
): Author => {
  if (!author) {
    throw new Error(errorMessage);
  }

  return author;
};

export const buildAuthorUpdatePayload = (authorData: Partial<Author>) => ({
  name: authorData.name,
  first_name: authorData.first_name,
  avatar_url: authorData.avatar_url,
  color: authorData.color,
});

export const shouldFallbackToLegacyAuthorTokenLookup = (
  error: { message?: string } | null
) => isMissingAuthorByTokenFunction(error);
